import {SystemConfig, useGetSystemConfig} from "./webrpc-client.gen.ts";
import {z} from "zod/v4";
import {InfallibleUseResult, pendingUseResult, successUseResult} from "../util/hookutil.tsx";

export const ExtendedSystemConfig = z.object({
    ...SystemConfig.shape,
    showInspectorFacets: z.optional(z.boolean()),
    quickInspectorActions: z.optional(z.boolean()),
    quickSupervisorActions: z.optional(z.boolean()),
});
export type ExtendedSystemConfig = z.infer<typeof ExtendedSystemConfig>;

export function useSystemConfig(): InfallibleUseResult<ExtendedSystemConfig> {
    const tqrv = useGetSystemConfig();
    if (tqrv.isPending) {
        return pendingUseResult;
    }

    switch (tqrv.data.vendor) {
        case "sanyu":
            return successUseResult({
                ...tqrv.data,
                showInspectorFacets: true,
                quickInspectorActions: true,
                quickSupervisorActions: true,
            });
        case "shinwa":
            return successUseResult({
                ...tqrv.data,
                showInspectorFacets: false,
                quickInspectorActions: true,
                quickSupervisorActions: true,
            });
        default:
            return successUseResult({...tqrv.data});
    }
}


